<template>
  <div>
    <!-- link-input -->
    <div v-if="type === 'link-input'" class="link-input-container" :classs="{'readonly': readonly}">
      <input v-if="editMode" class="w-full h-full" ref="linkInput" type="text" :readonly="readonly" :placeholder="placeholder" v-model="inputValue" @blur="inputBlur" />
      <span v-else class="w-full" style="overflow: hidden; text-overflow:ellipsis; color: #3C3C3C;" :href="inputValue" target="_blank">{{ displayValue }}</span>
      <div class="border-left">
        <feather-icon icon="EditIcon" @click="editText"/>
      </div>
    </div>

    <div v-if="type === 'label-and-input'" class="label-and-input-container">
      <span v-if="readonly" class="w-full" style="overflow: hidden; text-overflow:ellipsis; color: #3C3C3C;" :href="inputValue" target="_blank">{{ displayValue }}</span>
      <div v-else class="w-full h-full">
        <input class="w-full h-full" type="text" :readonly="readonly" :placeholder="placeholder" v-model="inputValue" />
        <span class="px-2" style="color:#7E72F2; cursor: pointer; " @click="onClickSave">{{ $t('확인') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditInput",
  props: {
    value: String,
    placeholder: String,
    readonly: Boolean,
    type: {
      type: "label-and-input" | "link-input",
      default: () => "link-input"
    },
    displayText: String, // 표시용 텍스트 (번역된 텍스트)
    useDisplayText: {
      type: Boolean,
      default: false  // 기본값은 false로 설정하여 기존 동작 유지
    },
  },
  watch: {
    value: {
      handler(value) {
        this.inputValue = value;
      },
    },
  },
  computed: {
    displayValue() {
      return this.useDisplayText? this.displayText : this.inputValue
    }
  },
  data() {
    return {
      editMode: false, // 수정 중 인지
      inputValue: this.value,
    };
  },
  methods: {
    inputBlur() {
      this.editMode = false;
      this.$emit("input", this.inputValue)
    },
    editText() {
      this.editMode = true;
      this.$nextTick(() => {
        this.$refs.linkInput.focus();
      });
    },
    onClickSave () {
      this.$emit("input", this.inputValue)
    }
  },
}
</script>

<style lang="scss" scoped>
.link-input-container {
  position: relative;

  display: grid;
  grid-template-columns: 1fr 48px;
  align-items: center;

  width: 100%;
  font-size: 1rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  box-sizing: border-box;
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);

  outline: none;
  text-transform: none;
  text-decoration: none;

  transition: all 0.3s ease;

  .feather-icon {
    width: 20px;
    height: 20px;
    padding: 10px;
    box-sizing: content-box;
  }
  input {
    flex: 1;
    background: #fff;
    border: none;
    padding: 6px 10px !important;
    border-radius: 5px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  a {
    text-decoration: underline;
    padding: 6px 10px !important;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .edit-btn {
    min-width: 50px;
    text-align: center;
    color: #7e72f2;
    padding: 0 10px !important;
    margin-left: auto;
    cursor: pointer;
  }

  &.readonly {
    background-color: #fafafa;
    input {
      background-color: inherit;
    }
  }

  &:focus-within {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgb(0 0 0 / 15%);
  }
}

.label-and-input-container > div {
  display: flex;
  align-items: center;

  border: 1px solid #CDCDCD;
  border-radius: 5px;
  padding: 0.25rem;

  input {
    flex: 1;
    background: #fff;
    border: none;
    padding: 6px 10px !important;
    border-radius: 5px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
